import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAuthStore } from '../stores/auth.store'
import { UserAccount } from '../../../types/user'
import api from '../../../repository/api'
import { FETCH_ACCOUNT } from '../../../constants/endpoints'

export default function useUserAccount() {
  const { session, user, fetchUserLoading, setUser, setFetchUserLoading } = useAuthStore()
  const [error, setError] = useState<unknown>()

  const fetchUser = useCallback(async () => {
    if (!session?.idToken) return

    setFetchUserLoading(true)
    setError(undefined)

    try {
      const res = await api.get<UserAccount>(FETCH_ACCOUNT)
      setUser(res.data)
    } catch (err) {
      setError(err)
      setUser(undefined)
    } finally {
      setFetchUserLoading(false)
    }
  }, [session?.idToken, setUser, setFetchUserLoading])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return useMemo(
    () => ({
      data: user,
      isLoading: fetchUserLoading,
      error,
      fetchUser,
    }),
    [user, fetchUserLoading, error, fetchUser],
  )
}
